<template>
    <div class="location-map-helper" v-if="activeMapOnLocation" @click="handleClick">
        <div class="show-content">
            Visa innehåll
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LocationMapHelper',

  data () {
    return {
      contentWrapper: null,
      locationInfo: null,
      content: null,
      mounted: false
    }
  },

  mounted () {
    this.contentWrapper = document.getElementsByClassName('content-wrapper')[0]
    this.locationInfo = document.getElementById('locationInfo')
    this.content = document.getElementsByClassName('content')[0]
    this.mounted = true
  },

  methods: {
    handleClick: function () {
      this.$store.dispatch('setActiveMapOnLocation', false)
    },
    addRemoveHiddenClass: function (element, remove) {
      if (!element) return
      if (remove) {
        element.classList.remove('hidden')
      } else {
        element.classList.add('hidden')
      }
    }
  },

  computed: {
    ...mapState({
      activeMapOnLocation: state => state.ui.activeMapOnLocation
    })
  },

  watch: {
    activeMapOnLocation (newValue) {
      if (this.mounted) {
        if (newValue) {
          this.addRemoveHiddenClass(this.contentWrapper, false)
          this.addRemoveHiddenClass(this.locationInfo, false)
          this.addRemoveHiddenClass(this.content, false)

          this.content.style.transform = 'translateY(' + (this.content.clientHeight + 300) + 'px)'
        } else {
          this.addRemoveHiddenClass(this.contentWrapper, true)
          this.addRemoveHiddenClass(this.locationInfo, true)
          this.addRemoveHiddenClass(this.content, true)

          this.content.style.transform = 'translateY(0px)'
          this.content.focus()
        }
      }
    }
  }
}
</script>
